// Components
import PlanningSummaryCell from '@/views/components/proposals/grid-elements/PlanningSummaryCell';

// Namespaces
import * as ProposalElementNS from '../../ProposalElements';
import * as ProposalNS from '../../Proposal';
import { ComparisonItemBasedProposalDAO } from '../ProposalDAOImpl';
import { ComparisonItemDAO } from '../ProposalItemDAO';
import { DataPoints } from '../DataPoints';
import { ProposalDAOInterface } from '../ProposalDAO';
import { ProposalFieldDAO } from '../ProposalFieldDAO';
import { ProposalStyleClassNames } from '../../ProposalStyleClassNames';

// Types
import PlanningSummaryValue from '@/types/planning-summary-value';

// Utils
import { CURRENCY } from '@/utils/currency';

export default class PlanningSummaryDAO extends ComparisonItemBasedProposalDAO {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new PlanningSummaryDAO(proposal, proposalElement);
  }

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return [];
  }

  protected async build(): Promise<void> {
    let itemDAO: ComparisonItemDAO | null = null;
    while ((itemDAO = this.nextItem()) !== null) {
      const {
        planning,
        name,
        currency,
        performance: { percentGrowth },
      } = itemDAO.item;

      if (planning) {
        const { planAccount, planAccountId } = planning;
        const planCurrency: string | undefined = currency === CURRENCY.MIXED ? CURRENCY.CAD : currency;
        const onTrackAlignment = {
          assetAllocation: DataPoints.isAssetAllocationOnTrack(this.proposal.appUser, itemDAO.item, planAccount),
          rateOfReturn: DataPoints.isGrowthOnTrack(this.proposal, percentGrowth, planAccount?.targetRateOfReturn),
        };

        this.addPlanningSummaryField(itemDAO, '', {
          planAccountId,
          planAccount,
          currency: planCurrency,
          portfolioName: name,
          onTrackAlignment,
        });
      }
    }
  }

  private addPlanningSummaryField(itemDAO: ComparisonItemDAO, name: string, value: PlanningSummaryValue): PlanningSummaryValue {
    const field: ProposalFieldDAO = new ProposalFieldDAO(name, value, ProposalStyleClassNames.ProposalTableContent);
    field.cellType = PlanningSummaryCell;
    field.decimalPlace = 2;
    this.addFieldDAO(itemDAO, field);
    return value;
  }
}
